export default {
  /*用户上传附件（多文件）*/
  mulUploadFiles: "/api/attachments/multi-upload",
  /*获取业务分类树*/
  geTypeTree: "/api/appproc/biz-types-tree",
  /*获取最近使用模板*/
  getRecent: "/api/appproc/his-select/packages-flows?clientType=web",
  /*获取流程包配置列表*/
  getFlowPackages: (data: any) => {
    return `/api/appproc/biz-types/${data.typeId}/packages-flows?clientType=${data.clientType}`;
  },
  /*获取我的待发事项分页查询结果*/
  getToSendPages: "/api/appproc/packages/self/proc-page/todo",
  /*获取我的已发事项分页查询结果*/
  getSendPages: "/api/appproc/packages/self/proc-page/done",
  /*获取我的待办事项分页查询结果*/
  getTodoPages: "/api/appproc/packages/self/proc-task-page/todo",
  /*获取我的已办事项分页查询结果*/
  getDonePages: "/api/appproc/packages/self/proc-task-page/done",
  /*获取我的抄送事项分页查询结果*/
  getCopyPages: "/api/appproc/packages/self/proc-page/cc",
  /*[待发]流程事项无表单执行删除*/
  delSendNotForm() {
    return `/api/appproc/write/wait/del`;
  },
  /*获取我的办结事项分页查询结果*/
  getFinishPages: "/api/appproc/packages/self/proc-page/finished",
  /*获取终止事项分页查询结果*/
  getTermPages: "/api/appproc/packages/self/proc-page/terminal",
  /*获取我的待办分页查询结果*/
  getTodoAll: "/api/appproc/packages/self/todo",
  /*获取我的已办分页查询结果*/
  getDoneAll: "/api/appproc/packages/self/done",
  /*查询待发/待办条数*/
  getListTotal: "/api/appproc/packages/matter-total-num"
};
